import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { RemoveSidenavlistService } from 'src/app/public-website/buyer/services/remove-sidenavlist.service';

declare let $;

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  constructor(
    public translate: TranslateService,
    private removeSidenavService: RemoveSidenavlistService,
    @Inject(PLATFORM_ID) private platformID: any
  ) {
    this.translate.use('en');
  }

  @Input() title: string;
  @Input() message: string;
  @Input() redirectURL: string;

  ngOnInit(): void {
    this.removeSidenavService.emitSidenavO(false);
    if (platformBrowser(this.platformID)) {
      $(document).ready(function () {
        let whe = $(window).height();
        let hehe = $('.header').height();
        let fohe = $('.ekfe-footer').height();
        $('.main').css('min-height', whe - hehe - fohe - 50 - 36 - 120);
      });

      $(window).resize(function () {
        let whe = $(window).height();
        let hehe = $('.header').height();
        let fohe = $('.ekfe-footer').height();
        $('.main').css('min-height', whe - hehe - fohe - 50 - 36 - 120);
      });

      $('.bur-button').on('click', function () {
        $('.header-login-hide').slideToggle(500);
      });

      $(document).ready(function () {
        let p = $('.image-block').height();
        $('.business-over').css('top', p);
      });

      $(window).resize(function () {
        let p = $('.image-block').height();
        $('.business-over').css('top', p);
      });
    }
  }
}
